<div class="container-fluid psp-container">
  <div class="card mb-4">
    <div class="row align-items-center pt-3">
      <div class="col-lg-6 col-7">
        <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-3">
          <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
            <li class="breadcrumb-item text-primary psp-breadcrumb">
              <a
                class="text-primary"
                [routerLink]="['/patient-details', patientId]"
              >
                Patient Profile
              </a>
            </li>

            <li
              aria-current="page"
              class="breadcrumb-item active text-gray psp-breadcrumb"
            >
              Enroll to another program
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="title d-flex p-3 justify-content-between align-items-center">
      <h2>Enroll to another program</h2>
    </div>

    <div class="card-body">
      <form
        [formGroup]="enrollToAnotherProgramForm"
        (ngSubmit)="onEnrollToAnotherProgram()"
      >
        <h2>Personal details</h2>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="full-name">
                Full Name
              </label>
              <input
                type="text"
                formControlName="patientFullName"
                id="full-name"
                name="full-name"
                class="input form-control"
                placeholder="Full Name"
              />
              <div
                *ngIf="
                  enrollToAnotherProgramForm.controls.patientFullName.dirty &&
                  enrollToAnotherProgramForm.controls.patientFullName.errors
                "
                class="input-errors"
              >
                <p
                  *ngIf="
                    enrollToAnotherProgramForm.controls.patientFullName.errors
                      .required
                  "
                >
                  This field is required!
                </p>
                <p
                  *ngIf="
                    !enrollToAnotherProgramForm.controls.patientFullName.errors
                      .namePattern
                  "
                >
                  You should type a correct name!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="company"> Company Name</label>

              <ng-select
                formControlName="companyId"
                id="company"
                name="companyId"
                (change)="onCompanyChange($event)"
                #company
                appCheckValidity
                [appCheckValidity]="company"
                placeholder=" Choose Company"
                dropdownPosition="bottom"
                [clearable]="false"
                required
              >
                <ng-option *ngFor="let company of companies" [value]="company.id">
                  {{ company.name }}
                </ng-option>
              </ng-select>
            </div>
        </div>


        <div class="col-md-4">
          <div class="form-group">
            <label class="form-control-label" for="program"> Program Name </label>
            <ng-select
              formControlName="patientProgramId"
              placeholder="Select Program"
              id="program"
              name="program"
              (change)="onProgramChange()"
              required
              #program
              appCheckValidity
              [clearable]="false"
              [appCheckValidity]="program"
            >
              <ng-option *ngFor="let program of programList" [value]="program.id">
                {{ program.name }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div formGroupName="patientIds" class="form-group">
              <div class="d-flex justify-content-between">
                <label
                  *ngIf="!enrollToAnotherProgramForm.get('patientIds.isPassportId').value"
                  for="national-id"
                  class="form-control-label"
                >
                  National ID
                </label>
                <label
                  *ngIf="enrollToAnotherProgramForm.get('patientIds.isPassportId').value"
                  for="passport-id"
                  class="form-control-label"
                >
                  Passport ID
                </label>
                <label
                  class="custom-toggle custom-toggle-default custom-toggle-95"
                >
                  <input formControlName="isPassportId" type="checkbox" />
                  <span
                    class="custom-toggle-slider rounded-circle"
                    data-label-off="Passport Id"
                    data-label-on="National Id"
                  >
                  </span>
                </label>
              </div>
              <input
                *ngIf="!enrollToAnotherProgramForm.get('patientIds.isPassportId').value"
                formControlName="patientNationalId"
                class="input form-control"
                id="national-id"
                name="national-id"
                placeholder="National ID"
                type="number"
              />
              <input
                *ngIf="enrollToAnotherProgramForm.get('patientIds.isPassportId').value"
                formControlName="patientPassportId"
                class="input form-control"
                id="passport-id"
                placeholder="Passport ID"
                type="text"
                name="passport-id"
              />
              <div
                *ngIf="
                  enrollToAnotherProgramForm.controls.patientIds.dirty &&
                  enrollToAnotherProgramForm.controls.patientIds.errors
                "
                class="input-errors"
              >
                <p
                  *ngIf="
                    enrollToAnotherProgramForm.controls.patientIds.errors
                      .patientIdIsRequired
                  "
                >
                  National Id OR Passport Id is required!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="date-of-birth">
                Date Of Birth
              </label>
              <input
                formControlName="patientDateOfBirth"
                class="form-control"
                id="date-of-birth"
                type="date"
                name="date-of-birth"
              />
              <div
                *ngIf="
                  enrollToAnotherProgramForm.controls.patientDateOfBirth
                    .touched &&
                  enrollToAnotherProgramForm.controls.patientDateOfBirth.errors
                "
                class="input-errors"
              >
                <p
                  *ngIf="
                    enrollToAnotherProgramForm.controls.patientDateOfBirth
                      .errors.required
                  "
                >
                  This field is required!
                </p>
              </div>
            </div>
          </div>

          <div *ngIf="showRocheFields();" class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="subscriptionHistory">
                Subscription History
              </label>
              <input
                type="text"
                formControlName="subscriptionHistory"
                maxlength="50"
                id="subscriptionHistory"
                name="subscriptionHistory"
                class="input form-control"
                placeholder="Subscription History"
                (input)="preventWhiteSpace($event)"
                (keydown)="PreventWhiteSpaceAndNotifyWhenExceedMaxChars($event)"
                (blur)="displayErrorInSubscriptionHistory=false"
              />
             <div *ngIf="displayErrorInSubscriptionHistory" class="input-errors">
              <p >You can write up to 50 characters only</p>
             </div>
            </div>
          </div>
        </div>

        <h2>Phone details</h2>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="mobile-number">
                Mobile Number
              </label>
              <div class="input-group input-group-merge">
                <input
                  formControlName="patientMobileNumber"
                  name="phone"
                  class="form-control"
                  placeholder="Phone number"
                  type="text"
                />
                <div class="input-group-append">
                  <span class="input-group-text" (click)="onCopy()">
                    <i class="ni ni-ungroup"> </i>
                  </span>
                </div>
              </div>
              <div
                *ngIf="
                  enrollToAnotherProgramForm.controls.patientMobileNumber
                    .dirty &&
                  enrollToAnotherProgramForm.controls.patientMobileNumber.errors
                "
                class="input-errors"
              >
                <p
                  *ngIf="
                    enrollToAnotherProgramForm.controls.patientMobileNumber
                      .errors.required
                  "
                >
                  This field is required!
                </p>
              </div>
            </div>
          </div>
        </div>

        <h2>Location</h2>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="city"> City </label>
              <select
                formControlName="patientCityId"
                class="form-control"
                id="city"
                name="city"
                (change)="
                  onCityChange(enrollToAnotherProgramForm.value.patientCityId)
                "
              >
                <option [ngValue]="null" [disabled]="true">Select City</option>
                <option *ngFor="let city of cityList" [ngValue]="city.id">
                  {{ city.name }}
                </option>
              </select>
              <div
                *ngIf="
                  enrollToAnotherProgramForm.controls.patientCityId.dirty &&
                  enrollToAnotherProgramForm.controls.patientCityId.errors
                "
                class="input-errors"
              >
                <p
                  *ngIf="
                    enrollToAnotherProgramForm.controls.patientCityId.errors
                      .required
                  "
                >
                  This field is required!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="area"> Area </label>
              <select
                formControlName="patientAreaId"
                class="form-control"
                id="area"
                name="area"
              >
              <option [ngValue]="null" [disabled]="true">Select Area</option>
                <option *ngFor="let area of areaList" [ngValue]="area.id">
                  {{ area.name }}
                </option>
                <div
                  *ngIf="
                    enrollToAnotherProgramForm.controls.patientAreaId.touched &&
                    enrollToAnotherProgramForm.controls.patientAreaId.errors
                  "
                  class="input-errors"
                >
                  <p
                    *ngIf="
                      enrollToAnotherProgramForm.controls.patientAreaId.errors
                        .required
                    "
                  >
                    This field is required!
                  </p>
                </div>
              </select>
            </div>
          </div>
        </div>

        <hr />

        <h2>Subscription Details</h2>
        <div class="row"
          [style]="isInsulinProgramSelected()?'padding-bottom: 15px;':'padding-bottom: 30px;'">

          <div class="col-md-4">
            <app-upload-file 
            [acceptedFileTypes]="uploadFileTypes"
            [labelName]="'Upload Document'"
            (selectedFile)="onFileUploaded($event)"
            ></app-upload-file>
            <p style="font-size: 12px;">Max number of uploading documents is 10 with size 10 MBs and the allowed extensions are images and PDFs </p>
            </div>

          <div class="col-md-3">
            <button
            class="btn btn-primary ml-3" 
            style="margin-top: 30px;"
            placeholder="Clear" 
            (click)="clearDocuments()"
            [disabled]="uploadedDocuments?.length==0">
            Clear
            </button>
          </div>

          <div class="col-md-4" *ngIf="uploadedDocuments?.length>0">
            <p style="font-size: 15px;">Selected Documents:</p>
            <div *ngFor="let doc of uploadedDocuments">
              <span style="font-size: 12px;">{{ doc.name }}</span>
            </div>
          </div>
        </div>

        <div class="row" style="padding-bottom: 30px;" *ngIf="isInsulinProgramSelected()">

          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="insulinType"> Insulin Types</label>

              <ng-select
                name="insulinType" placeholder="Choose Insulin Type" dropdownPosition="bottom"
                formControlName="insulinTypeId"
                required
                [clearable]="false"
              >
                <ng-option *ngFor="let insulinType of insulinTypes" [value]="insulinType.id">
                  {{ insulinType.name }}
                </ng-option>
              </ng-select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="referralCenter"> Referral Centers</label>

              <ng-select
                name="referralCenter" placeholder="Choose Referral Center" dropdownPosition="bottom"
                formControlName="referralCenterId"
                required
                [clearable]="false"
                [searchable]="true"
              >
                <ng-option *ngFor="let referralCenter of referralCenters" [value]="referralCenter.id">
                  {{ referralCenter.name }}
                </ng-option>
              </ng-select>
            </div>
          </div>

        </div>

        <h2>Physician Details</h2>

        <div *ngIf="showRocheFields(); else EvaLilly">
          <div class="row" formGroupName="physicianDetails">
            <div class="col-md-4">
              <div class="form-group">
                <label class="form-control-label" >
                  Select Doctor Type
                </label>
                <ng-select placeholder="Select Roch Type" notFoundText="No Type Found" dropdownPosition="bottom"
                           [searchable]="false" [closeOnSelect]="true" [clearSearchOnAdd]="false"
                           [clearable]="false"
                           (change)="onRocheTypeChange($event)" formControlName="rocheType" >

                  <ng-option *ngFor="let pair of rocheTypes" [value]="pair.id">{{ pair.name }}</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="form-control-label" >
                  Select Doctor Code
                </label>
                <ng-select placeholder="Select Serial Number"
                           notFoundText="No SerialNumber Found"
                           dropdownPosition="bottom"
                           [searchable]="true"
                           [clearable]="false"
                           [closeOnSelect]="true"
                           [clearSearchOnAdd]="false"
                           (change)="onDoctorSerialNumberChange($event)" formControlName="serialNumber"
                >
                  <ng-option *ngFor="let item of serialNumbersByType" [value]="item">{{ enrollToAnotherProgramForm.get('physicianDetails.rocheType').value }}-{{ item }}</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="form-control-label" for="full-name">
                  Doctor Name
                </label>
                <input name="doctorName" class="form-control input" type="text" formControlName="doctorName" required readonly>
              </div>
            </div>
          </div>
        </div>

        <ng-template #EvaLilly>
          <div class="row" formGroupName="physicianDetails">
            <div class="col-md-4">
              <div class="form-group">
                <label class="form-control-label">
                  Doctor Specialty
                </label>
                <app-doctor-specialty
                  (specialtyChanged)="onChangeDoctorSpeciality($event)"
                  [companyId]="companyId"
                ></app-doctor-specialty>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label class="form-control-label" for="doctor-name">
                  Doctor Name
                </label>
                <app-doctor-names-selector
                        formControlName="doctorName"
                        id="doctor-name"
                        name="drName"
                        [companyId]="companyId"
                        [specialtyId]="specialtyId"
                        (doctorNameChanged)="doctorNameChanged($event)"
                ></app-doctor-names-selector>

                <div
                  *ngIf="enrollToAnotherProgramForm.get('physicianDetails.doctorName').dirty && enrollToAnotherProgramForm.get('physicianDetails.doctorName').errors"
                  class="input-errors"
                >
                  <p *ngIf="!enrollToAnotherProgramForm.get( 'physicianDetails.doctorName' ).errors.required">
                    This field is required!
                  </p>
                  <p *ngIf=" !enrollToAnotherProgramForm.get( 'physicianDetails.doctorName' ).errors.namePattern">
                    You should type a correct name!
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="form-control-label" for="hospital-name">
                  Hospital Name
                </label>
                <input
                  formControlName="hospitalName"
                  name="hospitalName"
                  class="form-control"
                  id="hospital-name"
                />
              </div>
            </div>
          </div>
        </ng-template>

        <div class="row psp-action-button-container mt-4">
          <div class="col btns-block">
            <button
              class="btn bg-gray text-white"
              type="button"
              (click)="onReset()"
            >
              Cancel
            </button>
            <button
              class="btn btn-primary ml-3"
              type="submit"
              [disabled]="isFormInvalid()"
            >
              Confirm
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
